import { Card, FlexDiv, H1, H3, P } from 'components/generic/HomePageComponents'
import { TransitionImage } from './Styled'

const HowItWorksCard = ({ step, content: { description, title, imageUrl, imageAlt } }) => (
  <Card mr={['0px', '40px', '40px']} width={['75vw', '220px', '33%']} mb='35px'>
    <FlexDiv justifyContent='center'>
      <TransitionImage width={['300px', '225px', '300px']} src={imageUrl} alt={imageAlt} />
    </FlexDiv>
    <H3
      textAlign={['center', 'left', 'left']}
      color='inverseColor'
      mb='0px'
      fontWeight='700'
      fontSize='18px'
    >
      {step}
    </H3>
    <H1
      fontSize={['25px', '25px', '30px']}
      lineHeight='30px'
      mb='10px'
      mt='0px'
      textAlign={['center', 'left', 'left']}
    >
      {title}
    </H1>
    <P
      fontSize={['18px', '20px', '22px']}
      textAlign={['center', 'left', 'left']}
      maxWidth='none'
      mt='5px'
    >
      {description}
    </P>
  </Card>
)

export default HowItWorksCard
